// Polyfill composedPath() for old browsers
// This version excludes document and window from the path for simplicity
if (!Event.prototype.composedPath) {

  Event.prototype.composedPath = function composedPath() {

    let element = this.target;

    if (!element) {
      return [];
    }

    const path = [element];

    while (element.parentElement) {
      element = element.parentElement;
      path.push(element);
    }

    return path;

  };

}

/**
 * Checks whether `event` is a click inside `element`
 */
export function clickIsInside(event, element) {
  return event.composedPath().some(el => el === element);
}
